import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Inject, Component } from '@angular/core';

export interface ConfirmDialogData {
    message: string,
    title: string,
    yes: string,
    no: string
}

@Component({
    selector: 'confirm-dialog',
    templateUrl: 'confirm.dialog.html',
})
export class ConfirmDialog {
  
    constructor(public dialogRef: MatDialogRef<ConfirmDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {}
  
    // returnYes(): void {
    //     this.dialogRef.close({result: true});
    // }

    // returnNo(): void {
    //     this.dialogRef.close({result: null});
    // }
  
}